import React, { Component } from 'react';

function SaveButton({ onClick, children }) {
    return <button className="bhSaveBtn" onClick={onClick}>{children || 'Save'}</button>;
}

class DeleteButton extends Component {
    constructor(props) {
        super(props);
        this.state = { confirming: false };
    }

    render() {
        var label = this.props.children || 'Delete';
        var title = this.props.title || ('Delete ' + (typeof label === 'string' ? label.replace('Delete', '').trim() : '')).trim();
        return (
            <>
                <button className="bhDeleteBtn" onClick={function() { this.setState({ confirming: true }); }.bind(this)}>{label}</button>
                {this.state.confirming && (
                    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                        <div style={{ background: '#fff', borderRadius: '10px', padding: '28px 32px', width: '280px', textAlign: 'center', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}>
                            <div style={{ fontSize: '18px', fontWeight: '700', color: '#222', marginBottom: '8px' }}>{title || 'Delete?'}</div>
                            <div style={{ fontSize: '14px', color: '#888', marginBottom: '24px' }}>This cannot be undone.</div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button onClick={function() { this.setState({ confirming: false }); }.bind(this)}
                                    style={{ flex: 1, padding: '9px 18px', border: '1px solid #ccc', borderRadius: '6px', background: 'none', color: '#555', fontSize: '13px', fontWeight: '600', cursor: 'pointer', appearance: 'none', WebkitAppearance: 'none' }}>
                                    Cancel
                                </button>
                                <button onClick={function() { this.setState({ confirming: false }); this.props.onClick(); }.bind(this)}
                                    style={{ flex: 1, padding: '9px 18px', border: '1px solid #e74c3c', borderRadius: '6px', background: 'none', color: '#e74c3c', fontSize: '13px', fontWeight: '600', cursor: 'pointer', appearance: 'none', WebkitAppearance: 'none' }}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export { SaveButton, DeleteButton };
